<template>
  <svg
    width="26"
    height="17"
    viewBox="0 0 26 17"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_9255_1368)">
      <path
        d="M15.6191 14V14.5C15.6191 15.3284 14.9476 16 14.1191 16H2.11914C1.2907 16 0.619141 15.3284 0.619141 14.5V6.5C0.619141 5.67156 1.2907 5 2.11914 5H2.61914V6.5H2.30664C2.25691 6.5 2.20922 6.51975 2.17406 6.55492C2.1389 6.59008 2.11914 6.63777 2.11914 6.6875V14.3125C2.11914 14.3622 2.1389 14.4099 2.17406 14.4451C2.20922 14.4802 2.25691 14.5 2.30664 14.5H13.9316C13.9814 14.5 14.0291 14.4802 14.0642 14.4451C14.0994 14.4099 14.1191 14.3622 14.1191 14.3125V14H15.6191ZM16.9316 3.5H5.30664C5.25691 3.5 5.20922 3.51975 5.17406 3.55492C5.1389 3.59008 5.11914 3.63777 5.11914 3.6875V11.3125C5.11914 11.3622 5.1389 11.4099 5.17406 11.4451C5.20922 11.4802 5.25691 11.5 5.30664 11.5H16.9316C16.9814 11.5 17.0291 11.4802 17.0642 11.4451C17.0994 11.4099 17.1191 11.3622 17.1191 11.3125V3.6875C17.1191 3.63777 17.0994 3.59008 17.0642 3.55492C17.0291 3.51975 16.9814 3.5 16.9316 3.5ZM17.1191 2C17.9476 2 18.6191 2.67156 18.6191 3.5V11.5C18.6191 12.3284 17.9476 13 17.1191 13H5.11914C4.2907 13 3.61914 12.3284 3.61914 11.5V3.5C3.61914 2.67156 4.2907 2 5.11914 2H17.1191ZM8.86914 5.5C8.86914 6.19034 8.30948 6.75 7.61914 6.75C6.9288 6.75 6.36914 6.19034 6.36914 5.5C6.36914 4.80966 6.9288 4.25 7.61914 4.25C8.30948 4.25 8.86914 4.80966 8.86914 5.5ZM6.61914 8.5L7.85398 7.26516C8.00042 7.11872 8.23786 7.11872 8.38433 7.26516L9.61914 8.5L12.854 5.26516C13.0004 5.11872 13.2379 5.11872 13.3843 5.26516L15.6191 7.5V10H6.61914V8.5Z"
      />
    </g>
    <path
      d="M21.9245 5.76136V0H23.0708V5.76136H21.9245ZM19.6191 3.4517V2.3054H25.3805V3.4517H19.6191Z"
    />
    <defs>
      <clipPath id="clip0_9255_1368">
        <rect width="18" height="16" transform="translate(0.619141 1)" />
      </clipPath>
    </defs>
  </svg>
</template>
